export { ScreenRecordProvider, useScreenRecord, type UploadedRecording } from './ScreenRecordProvider';
